"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradients = void 0;
const redalerts_theme_palette_1 = require("@redwigwam/redalerts.theme.palette");
exports.gradients = {
    purpleToPink: `linear-gradient(90deg, ${redalerts_theme_palette_1.colours.purple} 0%, ${redalerts_theme_palette_1.colours.pink} 100%)`,
    purpleToPinkLight: `linear-gradient(0deg, ${redalerts_theme_palette_1.colours.pink}40, ${redalerts_theme_palette_1.colours.pink}40),
  linear-gradient(90deg, ${redalerts_theme_palette_1.colours.purple} 0%, ${redalerts_theme_palette_1.colours.pink} 100%);`,
};
//# sourceMappingURL=gradients.js.map